import { atom } from 'recoil';
import { OwnTeamTableFiltersState } from '../../types/navigation';


export const initialOwnTeamTableFiltersState: OwnTeamTableFiltersState = {
  selectedMaxAge: [],
  selectedContractStatus: [],
  selectedNationalities: [],
  selectedLocalities: [],
  selectedTeamRoles: [],
  tableSortBy: undefined,
};


export const ownTeamTableFiltersState = atom<OwnTeamTableFiltersState>({
  key: 'ownTeamTableFilters',
  default: initialOwnTeamTableFiltersState,
});
